module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/cerrar-session-modal/cerrar-session-modal.component.scss
// module id = ./src/app/components/partials/cerrar-session-modal/cerrar-session-modal.component.scss
// module chunks = main